import { Resources } from "Translations/Resources";

const StepResources = Resources.Onboarding.Steps.Documents;

export const SecondDocumentTypes = {
  Passport: "Passport",
  DrivingLicense: "DrivingLicense",
  Other: "Other",
} as const;

export const SECOND_DOCUMENT_TYPES = Object.values(SecondDocumentTypes);

export type SecondDocumentType =
  (typeof SecondDocumentTypes)[keyof typeof SecondDocumentTypes];

export const SECOND_DOCUMENT_TYPE_OPTIONS: Array<{
  value: SecondDocumentType;
  labelKey: string;
}> = [
  {
    value: "DrivingLicense",
    labelKey: StepResources.Forms.SecondDocumentTypeDrivingLicense,
  },
  {
    value: "Passport",
    labelKey: StepResources.Forms.SecondDocumentTypePassport,
  },
  {
    value: "Other",
    labelKey: StepResources.Forms.SecondDocumentTypeOther,
  },
];

export type PersonalDocumentModel = {
  firstDocument: {
    frontSide: File;
    backSide: File;
  };
  secondDocument?: {
    documentType: SecondDocumentType;
    frontSide: File;
    backSide?: File;
  };
};
